/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * 31 Milk St # 960789 Boston, MA 02196 USA.
 *
 * Copyright (c) 2025 (original work) Open Assessment Technologies SA;
 */
import config from '@/config';
import { FEATURE_SCORING_ASSIGNMENTS } from '@/constants/features.js';
import { getFeaturesGuard } from '@/core/guards/featureFlagGuard.js';
import { multiGuard } from '@/core/guards/guardComposer.js';
import { getPermissionsGuard } from '@/core/guards/permissionsGuard';

export const routing = [
    {
        path: [config.routes.scoringAssignments.home],
        guard: multiGuard([
            getFeaturesGuard(FEATURE_SCORING_ASSIGNMENTS),
            getPermissionsGuard([{ resource: 'portal.scoring-assignments', scopes: ['view'] }])
        ]),
        controller: () => import('./controllers/scoring-assignments.js')
    },
    {
        path: [config.routes.scoringAssignments.view],
        guard: multiGuard([
            getFeaturesGuard(FEATURE_SCORING_ASSIGNMENTS),
            getPermissionsGuard([{ resource: 'portal.scoring-assignments', scopes: ['view'] }])
        ]),
        controller: () => import('./controllers/scoringAssignment.js')
    }
];
